/**
 * Avoid nasty iFrame scrollbars on 3rd party content by getting iframe body height and setting that to iframe 
 * @returns {void}
 */
const setIframeHeight = () => {
  //console.log("setIframesHeight", "init");
  const iframes = document.querySelectorAll(".thirdpartyembed");
  if (!iframes) {
    return;
  }
  var _iframes = Array.from(iframes);

  const setHeight = () => {
    //console.log("setIframesHeight", "setHeight");
    _iframes.forEach((_iframe) => {
      //console.log("setIframesHeight ====", _iframe);
      _iframe.onload = () => {
          //console.log('iframe load');
        _iframe.height = _iframe.contentWindow.self.top.scrollY;
      };
    });
  };

  setHeight();
  //TODO: check on resize (after onload event)
  //window.addEventListener("resize", setHeight());
};
setIframeHeight();
